import $ from 'jquery'

Object.assign($.blockUI.defaults, {
    // message displayed when blocking (use null for no message) 
    message: null,

    // styles for the overlay 
    overlayCSS: Object.assign({}, $.blockUI.defaults.overlayCSS, {
        backgroundColor: 'transparent', 
    }),

    // fadeIn time in millis; set to 0 to disable fadeIn on block 
    fadeIn: 0, 
 
    // fadeOut time in millis; set to 0 to disable fadeOut on unblock 
    fadeOut: 0, 

    // callback method invoked when fadeIn has completed and blocking message is visible 
    onBlock: function() {
        let $el = $(this).parent()
    
        $el.addClass('ui-blocked')
    },

    // callback method invoked when unblocking has completed; the callback is 
    // passed the element that has been unblocked (which is the window object for page 
    // blocks) and the options that were passed to the unblock call: 
    //   onUnblock(element, options) 
    onUnblock: function(element) {
        $(element).removeClass('ui-blocked')
    }
})
